import { onAuthChange } from "./shared/api/client";

declare global {
  interface Window {
    FS?: (
      command: string,
      data: {
        [key: string]: unknown;
      }
    ) => void;
  }
}

onAuthChange((user) => {
  if (user && typeof window.FS === "function") {
    window.FS("setIdentity", {
      uid: user.id,
      properties: {
        displayName: user.displayName ?? "",
        username: user.username ?? "",
      },
    });
  }
});
